"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _index = require("../../utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ImgComponent =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ImgComponent, _PureComponent);

  function ImgComponent() {
    _classCallCheck(this, ImgComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(ImgComponent).apply(this, arguments));
  }

  _createClass(ImgComponent, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          onSort = _this$props.onSort,
          data = _this$props.data,
          drag = _this$props.drag,
          disabled = _this$props.disabled,
          canDelete = _this$props.canDelete,
          canReupload = _this$props.canReupload,
          _onDelete = _this$props.onDelete,
          ImgContentComponent = _this$props.ImgContentComponent,
          ImgSortComponent = _this$props.ImgSortComponent,
          DisplayComponent = _this$props.DisplayComponent,
          ItemAppendComponent = _this$props.ItemAppendComponent,
          MaskContentComponent = _this$props.MaskContentComponent,
          setUploader = _this$props.setUploader,
          index = _this$props.index,
          controls = _this$props.controls,
          required = _this$props.required,
          upload = _this$props.upload,
          type = _this$props.type,
          useFileAPI = _this$props.useFileAPI,
          onMouseOut = _this$props.onMouseOut,
          onMouseOver = _this$props.onMouseOver,
          onClick = _this$props.onClick,
          _this$props$useNewUI = _this$props.useNewUI,
          useNewUI = _this$props$useNewUI === void 0 ? false : _this$props$useNewUI,
          ReactDnD = _this$props.ReactDnD,
          sortDragItemClassName = _this$props.sortDragItemClassName,
          sortDragItemStyle = _this$props.sortDragItemStyle,
          onHover = _this$props.onHover; // 图片内容结构组件

      var component = _react["default"].createElement(ImgContentComponent, {
        onHover: onHover,
        ImgSortComponent: ImgSortComponent,
        index: index,
        drag: drag,
        disabled: disabled,
        useNewUI: useNewUI,
        useFileAPI: useFileAPI,
        type: type,
        upload: upload,
        canReupload: canReupload,
        className: (0, _classnames["default"])('img-li', _defineProperty({
          'img-li-video': type === 'video' || (0, _index.isVideo)(data.url)
        }, data.className, data.className)),
        data: data,
        style: data.style,
        canDelete: canDelete,
        required: required,
        onDelete: function onDelete(event) {
          _onDelete(event, data, index);
        },
        controls: controls,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        onClick: onClick,
        DisplayComponent: DisplayComponent,
        ItemAppendComponent: ItemAppendComponent,
        MaskContentComponent: MaskContentComponent,
        onSort: onSort,
        ReactDnD: ReactDnD,
        sortDragItemClassName: sortDragItemClassName,
        sortDragItemStyle: sortDragItemStyle
      });

      var result = null; // 可以上传才用setUploader设置一下

      if (canReupload && upload) {
        result = setUploader(component, {
          imageIndex: index,
          onComplete: function onComplete(err, xhr) {
            var resp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var fileTarget = arguments.length > 3 ? arguments[3] : undefined;
            var fileId = arguments.length > 4 ? arguments[4] : undefined;
            var propsOnComplete = _this.props.onComplete;

            if ((0, _spauiUtils.isFunction)(propsOnComplete)) {
              propsOnComplete(resp, index, data, fileTarget, fileId, err, xhr);
            }
          }
        });
      } else {
        result = component;
      }

      return result;
    }
  }]);

  return ImgComponent;
}(_react.PureComponent); // 图片结构组件


var _default = ImgComponent;
exports["default"] = _default;